import React, {useCallback, useState, useContext} from 'react'
import {AppContext} from '../../../context/context'

import {FilterBar} from './styles'

// Function used when filters are scrollable (on mobile)
function useScrollLeft() {
  // scrollLeft is how far the filter bar is scrolled from the left.
  const [scrollLeft, setscrollLeft] = useState(0)
  // scrollLeftMax is the maximum amount of scroll the user can scroll to the right.
  const [scrollLeftMax, setscrollLeftMax] = useState(0)
  // Set default scrollWidth to be 480px (DS small media size in pixels)
  const [scrollWidth, setscrollWidth] = useState(480)

  const onScroll = event => {
    setscrollWidth(event.target.scrollWidth)
    setscrollLeft(event.target.scrollLeft)
    setscrollLeftMax(event.target.scrollLeftMax)
  }

  return [scrollLeft, scrollLeftMax, scrollWidth, {onScroll}]
}

const FilterBarHeading = ({t}) => {
  const {dispatch, state} = useContext(AppContext)
  const [scrollLeft, scrollLeftMax, scrollWidth, scrollProps] = useScrollLeft()

  const handleOptionClick = useCallback(
    option => {
      if (option) {
        dispatch({
          payload: {
            filter: option,
          },
          type: 'UPDATE_FILTER',
        })
      }
    },
    [dispatch],
  )

  // Set the scroll when the width of the body is less than the scroll width.
  // We use `document.body.clientWidth` because `#filterScrollBar` is not rendered on pageload to get the width, but `body` and `#filterScrollBar` are the same width.
  function getScrollClass() {
    if (document.body.clientWidth < scrollWidth) {
      if (scrollLeft > 0 && scrollLeft < scrollLeftMax) {
        return 'both-shadow'
      } else if (scrollLeft === 0) {
        return 'right-shadow'
      } else {
        return 'left-shadow'
      }
    } else {
      return ''
    }
  }

  return (
    <FilterBar>
      <div {...scrollProps} className={getScrollClass()} id="filterScrollBar">
        {/* Most Relevant */}
        <button
          onClick={() => handleOptionClick('main')}
          data-testing="filter-main"
          className={
            state.filter === 'main' ? 'filterSelected' : 'filterUnselected'
          }
        >
          {t('header.filters.main')}
        </button>

        {/* eLaws */}
        <button
          onClick={() => handleOptionClick('elaws')}
          data-testing="filter-elaws"
          className={
            state.filter === 'elaws' ? 'filterSelected' : 'filterUnselected'
          }
        >
          {t('header.filters.elaws')}
        </button>

        {/* Data Catalogue */}
        <button
          onClick={() => handleOptionClick('data')}
          data-testing="filter-data"
          className={
            state.filter === 'data' ? 'filterSelected' : 'filterUnselected'
          }
        >
          {t('header.filters.data')}
        </button>
      </div>
    </FilterBar>
  )
}

export default FilterBarHeading
